import TextField from '@material-ui/core/TextField/TextField';
import { call } from '@packages/functions';
import { Field } from 'formik';
import React from 'react';
import { ErrorMessage } from './fields/common';

interface FormikFieldProps {
    name: string;
    label?: string;
    id?: string;
    onBlur?: (...args: any) => any;
    onChange?: (...args: any) => any;
    fieldProps?: Record<string, any>;
    textFieldProps?: Record<string, any>;
    type?: string;
}

/**
 * @deprecated Consider switching to ./fields/Textfield.js
 * @param props
 * @returns {*}
 * @constructor
 */
const FormikField = (props: FormikFieldProps) => {
    const { name, label, onBlur, onChange, fieldProps, textFieldProps, type = 'text' } = props;

    const handleOnBlur = (event, field, form) => {
        field.onBlur(event);
        if (typeof onBlur === 'function') {
            call(onBlur, event, field, form);
        }
    };

    const handleOnChange = (event, field, form) => {
        field.onChange(event);
        if (typeof onChange === 'function') {
            call(onChange, event, field, form);
        }
    };

    return (
        <>
            <Field name={name} {...fieldProps}>
                {({ field, form }) => (
                    <TextField
                        {...field}
                        onBlur={(event) => handleOnBlur(event, field, form)}
                        onChange={(event) => handleOnChange(event, field, form)}
                        type={type}
                        variant={'outlined'}
                        margin="dense"
                        fullWidth={true}
                        placeholder={label}
                        label={label}
                        {...textFieldProps}
                    />
                )}
            </Field>

            <ErrorMessage name={name} />
        </>
    );
};

export default FormikField;
